module.exports = __webpack_public_path__ + "sunsemweb/img/sh.c5c6f7af.png";